import { useContext } from "react";
import { Company } from "../../components/company/company";
import { Objects } from "../../components/objects/objects";
import { Profile } from "../../components/profile/profile";
import { LocaleContext } from "../../contexts/locale/locale";
import { Page } from "../page/page";

export const Home = () => {
	const { texts } = useContext(LocaleContext);

	return (
		<Page title={texts.home.hero.title} image="/images/home.jpg">
			<Profile />
			<Objects />
			<Company />
		</Page>
	);
};
